import React from "react";
import { MDBAnimation, MDBIcon } from "mdbreact";
import { FaFacebook, FaInstagram, FaTwitter, FaPhone } from "react-icons/fa";
import { ImPhoneHangUp } from "react-icons/im";
import { BiWorld } from "react-icons/bi";
import { IoMdPhonePortrait } from "react-icons/io";
import { SiGmail } from "react-icons/si";
export default function Contact() {
  return (
    <div className="row">
      <div className="col-md-12 col-lg-4 bag">
        <MDBAnimation reveal type="pulse" duration="1000ms" delay="0.4s">
          <div>
            <h2>Social Media</h2>
            <ul>
              <li>
                <FaFacebook color="blue" />
                <a
                  href="https://www.facebook.com/Mamba-House-102526298260803"
                  target="_blank"
                >
                  <strong>Mamba House</strong> (Software Company)
                </a>
              </li>
              <li>
                <FaInstagram color="brown" />
                <a
                  href="https://www.instagram.com/mamba___house/"
                  target="_blank"
                >
                  @mamba___house
                </a>
              </li>
              <li>
                <FaTwitter color="blue" />
                <a>mamba_house </a>
              </li>
            </ul>
          </div>
        </MDBAnimation>
      </div>
      <div className="col-md-12 col-lg-4 bag">
        <MDBAnimation reveal type="pulse" duration="1000ms" delay="0.7s">
          <div>
            <h2>Contact Info</h2>
            <ul>
              <li>
                <IoMdPhonePortrait color="blue" />
                <a>+92-334-8521520</a>
              </li>
              <li>
                <ImPhoneHangUp color="brown" />
                <a>+92-51-4580961</a>
                <br />
                <a style={{ marginLeft: 25.5 }}>+92-51-5405536</a>
              </li>
              <li>
                <SiGmail color="red" />
                <a>mambadevs@gmail.com</a>
              </li>
            </ul>
          </div>
        </MDBAnimation>
      </div>
      <div className="col-md-12 col-lg-4 bag">
        <MDBAnimation reveal type="pulse" duration="1000ms" delay="1s">
          <div className="freelance">
            <h2>Freelancing Site</h2>
            <ul>
              <li>
                <BiWorld color="green" />
                <a
                  href="https://www.fiverr.com/mamba_devs?up_rollout=true"
                  target="_blank"
                >
                  mamba_devs (Website)
                </a>
              </li>

              <li>
                <BiWorld color="green" />
                <a
                  href="https://www.fiverr.com/mambadevelopers?up_rollout=true"
                  target="_blank"
                >
                  mambadevelopers (Mobile)
                </a>
              </li>
              <li>
                <BiWorld color="green" />
                <a href="https://www.fiverr.com/mambaeditors" target="_blank">
                  mambaeditors
                </a>
              </li>
            </ul>
          </div>
        </MDBAnimation>
      </div>
    </div>
  );
}
